import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Calendar, Wallet, ClipboardList, Users } from 'lucide-react';

const items = [
    { to: '/home', label: 'Inicio', icon: Home, testId: 'bottom-nav-inicio' },
    { to: '/agenda', label: 'Agenda', icon: Calendar, testId: 'bottom-nav-agenda' },
    { to: '/wallet', label: 'Wallet', icon: Wallet, testId: 'bottom-nav-wallet' },
    { to: '/listas', label: 'Listas', icon: ClipboardList, testId: 'bottom-nav-listas' },
    { to: '/familia', label: 'Familia', icon: Users, testId: 'bottom-nav-familia' },
];

export default function BottomNav() {
    const { pathname } = useLocation();
    return (
        <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] h-[72px] bg-white border-t border-gray-100 flex justify-around items-center px-2 pb-safe z-40">
            {items.map(({ to, label, icon: Icon, testId }) => {
                const active = pathname === to || pathname.startsWith(to + '/');
                return (
                    <Link key={to} to={to} className="flex flex-col items-center gap-1 flex-1" data-testid={testId}>
                        <Icon className={`w-6 h-6 ${active ? 'text-brand' : 'text-gray-400'}`} />
                        <span className={`text-[11px] font-medium ${active ? 'text-brand' : 'text-gray-400'}`}>{label}</span>
                    </Link>
                );
            })}
        </nav>
    );
}
